<!--超级教研员-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="iframe-wrapper" >
            <iframe v-if="openUrl" :src="openUrl" frameborder="0" ></iframe>
        </div>
    </div>
</template>
<script>
import homeHead from "@/components/homeHead.vue";
import {gainXjUrl} from "@/api/admin/aiHome";

export default {
    components: {homeHead},
    name: "homeAiInstructor",
    data() {
        return {
           userInfo : JSON.parse(this.$storage.get("userInfo")),
           openUrl:'',
           loading: true,
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.superTeacher();
    },
    methods: {
       superTeacher(){
            gainXjUrl({userId: this.userInfo.userId}).then(res => {
                if (res.data.code === 1){
                    this.openUrl = res.data.data + this.$storage.get("token");
                }else {
                    this.loading = false;
                    this.$message({message: res.data.msg || '操作失败', type: 'info'});
                }
            })
            
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
}
.iframe-wrapper {
    flex: 1;
    margin-top: 20px;
    iframe {
        width: 100%;
        height: 100%;
        display: block;
        border: none;
    }
}
</style>
